import { styled } from '@fluentui/react';
import { NavLinkBase } from './nav-link.base';
import { getNavLinkStyles } from './nav-link.style';
export const NavLink = styled(NavLinkBase, getNavLinkStyles, undefined, { scope: 'NavLink' }, true);
//# sourceMappingURL=nav-link.js.map